import { Home, Store, Building2, Sun, Repeat, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../lib/data";

const ICONS = { Home, Store, Building2, Sun, Repeat };

export const Services = () => (
  <section id="services" data-testid="services-grid" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <Reveal className="max-w-2xl">
        <Overline>Nos services</Overline>
        <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          Un savoir-faire pour chaque surface vitrée
        </h2>
        <p className="mt-4 text-base text-slate-600 leading-relaxed">
          Du studio au centre commercial, nous adaptons nos techniques — perche à eau pure et
          raclette professionnelle — à chaque configuration.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.08}>
              <div
                data-testid={`service-card-${i + 1}`}
                className="group h-full rounded-3xl border border-slate-100 bg-slate-50/60 p-7 sm:p-8 transition-all duration-300 hover:-translate-y-1.5 hover:bg-white hover:shadow-xl hover:shadow-sky-900/10 hover:border-sky-100"
              >
                <span className="inline-flex w-12 h-12 items-center justify-center rounded-2xl bg-sky-100 text-sky-600 transition-colors group-hover:bg-sky-600 group-hover:text-white">
                  <Icon size={22} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <a
                  href="#devis"
                  data-testid={`service-card-${i + 1}-cta`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-sky-600 opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0"
                >
                  Demander un devis <ArrowRight size={14} />
                </a>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
